import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function getCompanyList() {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}admin/company?pagination=false`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
export function getQbTags() {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}question_bank/tags?pagination=false`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
